'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RulesModal = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _rules = require('redux/modules/rules');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RulesModal = exports.RulesModal = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(RulesModal, _Component);

  function RulesModal() {
    (0, _classCallCheck3.default)(this, RulesModal);
    return (0, _possibleConstructorReturn3.default)(this, (RulesModal.__proto__ || (0, _getPrototypeOf2.default)(RulesModal)).apply(this, arguments));
  }

  (0, _createClass3.default)(RulesModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          rules = _props.rules,
          onChangeInclude = _props.onChangeInclude,
          onChangeFormat = _props.onChangeFormat,
          saveState = _props.saveState;


      return _react2.default.createElement(_components.Rules, { rules: rules,
        onChangeInclude: onChangeInclude,
        onChangeFormat: onChangeFormat,
        saveState: saveState
      });
    }
  }]);
  return RulesModal;
}(_react.Component), _class.propTypes = {
  rules: _react.PropTypes.object,
  onChangeInclude: _react.PropTypes.func,
  onChangeFormat: _react.PropTypes.func,
  saveState: _react.PropTypes.func
}, _temp);


var mapStateToProps = function mapStateToProps(state) {
  return {
    rules: state.rules.rules
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, { onChangeInclude: _rules.onChangeInclude,
  onChangeFormat: _rules.onChangeFormat,
  saveState: _rules.saveState })(RulesModal);


//////////////////
// WEBPACK FOOTER
// ./src/containers/RulesModal/RulesModal.jsx
// module id = 1639
// module chunks = 0